<template>
  <Row class="right-box f-between f-y-center">
    <!-- 未登录状态显示登录/注册按钮 -->
    <Row v-if="!userStore.token" class="mr-16px">
      <div v-to="'/login'" class="pointer " :style="header_icon_gap">
        <div v-inmodule="['/login']" class="p-lr-12 h-32 header-hover-bg f-center font-14 bold radius-40 text-nowrap text-white!">
          {{ $t(`form.login`) }}
        </div>
      </div>
      <Link id="appHeader-to-register" to="/register" class="pointer" :style="header_icon_gap">
        <div v-inmodule="['/register']" class="p-lr-12 h-32 ml-4px f-center font-14 bold bg-primary radius-40 c-white text-nowrap">
          {{ $t(`form.register`) }}
        </div>
      </Link>
    </Row>

    <!-- 充值按钮 -->
    <ThemeButton
      v-if="userStore.token"
      size="sm"
      class="ml-20px"
      :font-weight="700"
      @click="obRecharge"
    >
      <template v-if="!isSmallScreen" #prefix>
        <IconSvg name="icon-ICON_Deposit" class="font-18" />
      </template>
      <span class="text-nowrap">{{ $t('wallet.recharge') }}</span>
    </ThemeButton>

    <!-- 资产下拉菜单 -->
    <WalletMenu v-if="userStore.token" :isSmallScreen="isSmallScreen" />

    <div v-if="userStore.token" class="bg-333 w-1 h-20 ml-10px" />

    <Row class="h-100b gap-4px" :class="{ 'ml-20px': userStore.token }" y="c">
      <!-- 个人中心下拉菜单 -->
      <UserMenu v-if="userStore.token" />

      <QuerySymbol :isSmallScreen="isSmallScreen" />

      <!-- 消息中心 -->
      <MessageMenu />

      <!-- 下载App -->
      <DownloadMenu :is-has-set-icon="isHasSetIcon" />

      <!-- 交易设置按钮 -->
      <!-- <Row v-if="userStore.token && ['/trade', '/futures'].includes(businessPath)" class="h-24">
      <IconSvg
        class="c-t title transition pointer c-hover-primary font-20"
        name="icon-setting"
        test-key="down-app"
        @click="() => diaTradeStyleSetData.show = true"
      />
      </Row> -->

      <!-- 语言切换 -->
      <LanguageMenu />
    </Row>

    <!-- 弹窗组件 -->
    <DiaTradeStyleSet v-model="diaTradeStyleSetData.show" />
  </Row>
</template>

<script setup>
import WalletMenu from './WalletMenu.vue'
import UserMenu from './UserMenu.vue'
import MessageMenu from './MessageMenu.vue'
import DownloadMenu from './DownloadMenu.vue'
import LanguageMenu from './LanguageMenu.vue'
import { getBusinessPath } from '@/utils/localeRoute.js'

const props = defineProps({
  gap: {
    default: '14'
  },
  isSmallScreen: {
    required: true,
  }
})

const userStore = useUserStore()
const route = useRoute()
const businessPath = $computed(() => getBusinessPath(route.path))

const diaTradeStyleSetData = reactive({
  show: false
})

const header_icon_gap = $computed(() => {
  return { 'margin-left': `${props.gap}px` }
})

const tips = computed(() => {
  if (userStore?.info?.nickName) {
    return userStore?.info?.nickName
  }
  if (userStore?.info?.phone) {
    return $f.hidePhone(userStore?.info?.phone)
  }
  if (userStore?.info?.email) {
    return $f.hideEmail(userStore?.info?.email)
  }
})

const isHasSetIcon = () => {
  return ['/trade', '/futures'].includes(businessPath)
}

const obRecharge = () => {
  const obj = {
    path: '/home',
    title: 'header.home',
  }
  router.push({
    name: 'Recharge',
    query: { path: JSON.stringify([obj]) }
  })
}
</script>

<style lang="scss">
.header-hover-bg {
  &:hover {
    background-color: #2C2C2C;
  }
}
</style>
